import React from 'react';
import CookieConsent from 'react-cookie-consent';
import {isMobile} from 'react-device-detect';
import styles from './styles';

const CookieBanner = () => (
  <CookieConsent
    style={isMobile ? styles.mobileStyle : styles.style}
    buttonStyle={styles.buttonStyle}
    contentStyle={styles.contentStyle}
    buttonText="Ok, understood"
  >
    <div style={isMobile ? styles.mobileTitle : styles.title}>We use cookies</div>
    We use cookies to improve your user experience. By using this website you agree to these cookies being set. To find
    out more including cookies we use & how to manage cookies see our Cookies Policy.
  </CookieConsent>
);

export default CookieBanner;
